import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppMainComponent } from 'src/app/app.main.component';
import { BehaviorSubject } from 'rxjs';
import { NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-items-view',
    templateUrl: './items-view.component.html',
})
export class ItemsViewComponent extends BaseComponent implements OnInit {

    tabs: any[] = [
        {label: 'Items', icon: 'pi pi-fw pi-id-card', routerLink: '/items', routerLinkActiveOptions: {paths: 'exact', queryParams: 'ignored', fragment: 'exact', matrixParams: 'exact'}},
        {label: 'Incomplets', icon: 'pi pi-fw pi-exclamation-triangle', routerLink: '/items/incomplet', routerLinkActiveOptions: {paths: 'exact', queryParams: 'ignored', fragment: 'exact', matrixParams: 'exact'}},
            {label: 'Archive', icon: 'pi pi-fw pi-folder', routerLink: '/items/archive', routerLinkActiveOptions: {paths: 'exact', queryParams: 'ignored', fragment: 'exact', matrixParams: 'exact'}},
    ];
    
    activeItem: any;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        public router: Router,
        appMain: AppMainComponent
    ) { 
        super(sdb, profilService, route, router, appMain);
    }

    ngOnInit() {
    }
}
